
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyLightFloat as ObiSimplifiedBuoyLightFloatElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-light-float.js';
 
 
 

 
 export const ObiSimplifiedBuoyLightFloat = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-light-float',
   elementClass: ObiSimplifiedBuoyLightFloatElement,
   events: {
     
   }
  });
 
 